// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__wR1gh","col":"Table_col__2RFJU","fulfillmentStatus":"Table_fulfillmentStatus__afZ7f","emailCol":"Table_emailCol__28rvm"};